module.exports = __webpack_public_path__ + "static/media/icon-medical.9fc4099c.svg";